import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ede37c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"text-align":"center"},
  class: "GYONO cwS_0"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 2,
  style: {"font-size":"14px"}
}
const _hoisted_5 = {
  style: {"text-align":"center"},
  class: "GYONO cwS_1"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  style: {"text-align":"center","position":"relative"},
  class: "CLAIMNO cwS_2"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "SALESMONTH cwS_3" }
const _hoisted_10 = {
  style: {"text-align":"left"},
  class: "ITEMIZE meisaiCont cwU_4-5 selectBorderNone"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  style: {"text-align":"left"},
  class: "COURSE cwS_5"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  style: {"text-align":"left"},
  class: "COURSE cwS_5-1 selectBorderNone"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  style: {"text-align":"left"},
  class: "COURSE meisaiCont cwS_5-2"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  style: {"text-align":"center"},
  class: "BREAK_DOWN cwS_6"
}
const _hoisted_21 = {
  style: {"text-align":"center"},
  class: "BREAK_DOWN cwS_6-1"
}
const _hoisted_22 = {
  class: "SUPPLIER_CD cwS_7 tdDisables selectBorderNone",
  style: {"height":"25px"}
}
const _hoisted_23 = {
  key: 0,
  class: "selectSupplierBt"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"clear":"both","display":"none"} }, null, -1))
const _hoisted_26 = {
  style: {"text-align":"left"},
  class: "SUM cwS_8"
}
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  style: {"text-align":"center"},
  class: "SYOHIZEI_RITU cwS_9 selectBorderNone"
}
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["value"]
const _hoisted_31 = {
  style: {"text-align":"center","position":"relative"},
  class: "PAYMENT_FLG cwS_9-2 tdDisables"
}
const _hoisted_32 = ["checked", "disabled"]
const _hoisted_33 = { class: "PAYMENT_YOTEI_DATE cwS_10" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-info-circle" }, null, -1))
const _hoisted_35 = ["checked", "disabled"]
const _hoisted_36 = { class: "BIKO cwS_12" }
const _hoisted_37 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mt_dtp4month = _resolveComponent("Mt_dtp4month")!
  const _component_Mt_dtp = _resolveComponent("Mt_dtp")!
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_VTooltip = _resolveComponent("VTooltip")!

  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(["supplierrow", { selectedRow: _ctx.item.isSelect }]),
    onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.selectRow())),
    onFocusout: _cache[27] || (_cache[27] = ($event: any) => (_ctx.calcProfit()))
  }, [
    (_ctx.supplyInfo.isLinkMode)
      ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
          (_ctx.item.c_pro2doc_id == null)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "button",
                class: "btn-secondary form-control form-control-sm selectBtn",
                style: {"height":"25px","line-height":"13px"},
                disabled: 
          //ロック機能
          (_ctx.item.c_supply_flag_lock == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //処理機能
          _ctx.btnDisable ||
          //統合ロック※仕入選択機能では、ロック対象月をnullにしているのでロックはかからない。金額が変らないのでロック対象外の判断。
          _ctx.isHolisticlock()
        ,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.upd4Doc(true))),
                value: "未紐付"
              }, null, 8, _hoisted_2))
            : (
          _ctx.item.c_pro2doc_id != null &&
          _ctx.item.c_pro2doc_id == _ctx.supplyInfo.pro2Doc!.c_pro2doc_id
        )
              ? (_openBlock(), _createElementBlock("input", {
                  key: 1,
                  type: "button",
                  class: "btn-primary form-control form-control-sm selectBtn",
                  style: {"height":"25px","line-height":"13px"},
                  disabled: 
          //ロック機能
          (_ctx.item.c_supply_flag_lock == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //処理機能
          _ctx.btnDisable ||
          //統合ロック※仕入選択機能では、ロック対象月をnullにしているのでロックはかからない。金額が変らないのでロック対象外の判断。
          _ctx.isHolisticlock()
        ,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.upd4Doc(false))),
                  value: "紐付済"
                }, null, 8, _hoisted_3))
              : (
          _ctx.item.c_pro2doc_id != null &&
          _ctx.item.c_pro2doc_id != _ctx.supplyInfo.pro2Doc!.c_pro2doc_id
        )
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "別文書"))
                : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("td", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        readonly: "true",
        disabled: 
          //ロック機能による編集不可
          (_ctx.item.c_supply_flag_lock == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //リンクモード時は編集不可
          _ctx.supplyInfo.isLinkMode ||
          //支払確定済みによる編集不可
          (_ctx.item.c_supply_flag_paid == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //統合ロック
          _ctx.isHolisticlock()
        ,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.c_supply_rownum) = $event))
      }, null, 8, _hoisted_6), [
        [_vModelText, _ctx.item.c_supply_rownum]
      ])
    ]),
    _createElementVNode("td", _hoisted_7, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        disabled: 
          //ロック機能による編集不可
          (_ctx.item.c_supply_flag_lock == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //リンクモード時は編集不可
          _ctx.supplyInfo.isLinkMode ||
          //支払確定済みによる編集不可
          (_ctx.item.c_supply_flag_paid == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //統合ロック
          _ctx.isHolisticlock()
        ,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.cnvClaimnumTmp) = $event))
      }, null, 8, _hoisted_8), [
        [_vModelText, _ctx.item.cnvClaimnumTmp]
      ])
    ]),
    _createElementVNode("td", _hoisted_9, [
      _createVNode(_component_Mt_dtp4month, {
        contdate: _ctx.item.cnvDateMonth,
        "onUpdate:contdate": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.item.cnvDateMonth) = $event)),
        class: "dtpJyutyuBulk jyutyuTable",
        minDate: _ctx.getMinDate(),
        disabledDates: _ctx.getDisabledDates(),
        disabled: 
          //ロック機能による編集不可
          (_ctx.item.c_supply_flag_lock == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //リンクモード時は編集不可
          _ctx.supplyInfo.isLinkMode ||
          //支払確定済みによる編集不可
          (_ctx.item.c_supply_flag_paid == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //統合ロック
          _ctx.isHolisticlock()
        
      }, null, 8, ["contdate", "minDate", "disabledDates", "disabled"])
    ]),
    _createElementVNode("td", _hoisted_10, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item.c_supply_subject) = $event)),
        disabled: 
          //ロック機能による編集不可
          (_ctx.item.c_supply_flag_lock == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //リンクモード時は編集不可
          _ctx.supplyInfo.isLinkMode ||
          //支払確定済みによる編集不可
          (_ctx.item.c_supply_flag_paid == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //統合ロック
          _ctx.isHolisticlock()
        
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opSubject, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.code,
            key: option.code
          }, _toDisplayString(option.label), 9, _hoisted_12))
        }), 128))
      ], 8, _hoisted_11), [
        [_vModelSelect, _ctx.item.c_supply_subject]
      ])
    ]),
    _createElementVNode("td", _hoisted_13, [
      _withDirectives(_createElementVNode("input", {
        type: "button",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.item.cnvItemName) = $event)),
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectItem())),
        disabled: 
          //ロック機能による編集不可
          (_ctx.item.c_supply_flag_lock == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //リンクモード時は編集不可
          _ctx.supplyInfo.isLinkMode ||
          //支払確定済みによる編集不可
          (_ctx.item.c_supply_flag_paid == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //統合ロック
          _ctx.isHolisticlock()
        
      }, null, 8, _hoisted_14), [
        [_vModelText, _ctx.item.cnvItemName]
      ])
    ]),
    _createElementVNode("td", _hoisted_15, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.item.c_supply_item) = $event)),
        disabled: 
          //ロック機能による編集不可
          (_ctx.item.c_supply_flag_lock == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //リンクモード時は編集不可
          _ctx.supplyInfo.isLinkMode ||
          //支払確定済みによる編集不可
          (_ctx.item.c_supply_flag_paid == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //統合ロック
          _ctx.isHolisticlock()
        
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opSupplyType, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.code,
            key: option.code
          }, _toDisplayString(option.label), 9, _hoisted_17))
        }), 128))
      ], 8, _hoisted_16), [
        [_vModelSelect, _ctx.item.c_supply_item]
      ])
    ]),
    _createElementVNode("td", _hoisted_18, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.item.c_supply_count) = $event)),
        disabled: 
          //ロック機能による編集不可
          (_ctx.item.c_supply_flag_lock == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //リンクモード時は編集不可
          _ctx.supplyInfo.isLinkMode ||
          //支払確定済みによる編集不可
          (_ctx.item.c_supply_flag_paid == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //統合ロック
          _ctx.isHolisticlock()
        
      }, null, 8, _hoisted_19), [
        [_vModelText, _ctx.item.c_supply_count]
      ])
    ]),
    _createElementVNode("td", _hoisted_20, [
      _createVNode(_component_Mt_dtp, {
        contdate: _ctx.item.cnvDateStart,
        "onUpdate:contdate": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.item.cnvDateStart) = $event)),
        holidays: _ctx.mastersData,
        "onUpdate:holidays": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.mastersData) = $event)),
        class: "dtpJyutyuBulk jyutyuTable",
        disabled: 
          //ロック機能による編集不可
          (_ctx.item.c_supply_flag_lock == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //リンクモード時は編集不可
          _ctx.supplyInfo.isLinkMode ||
          //支払確定済みによる編集不可
          (_ctx.item.c_supply_flag_paid == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //統合ロック
          _ctx.isHolisticlock()
        
      }, null, 8, ["contdate", "holidays", "disabled"])
    ]),
    _createElementVNode("td", _hoisted_21, [
      _createVNode(_component_Mt_dtp, {
        contdate: _ctx.item.cnvDateEnd,
        "onUpdate:contdate": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.item.cnvDateEnd) = $event)),
        holidays: _ctx.mastersData,
        "onUpdate:holidays": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.mastersData) = $event)),
        class: "dtpJyutyuBulk jyutyuTable",
        disabled: 
          //ロック機能による編集不可
          (_ctx.item.c_supply_flag_lock == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //リンクモード時は編集不可
          _ctx.supplyInfo.isLinkMode ||
          //支払確定済みによる編集不可
          (_ctx.item.c_supply_flag_paid == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //統合ロック
          _ctx.isHolisticlock()
        
      }, null, 8, ["contdate", "holidays", "disabled"])
    ]),
    _createElementVNode("td", _hoisted_22, [
      _createElementVNode("div", {
        class: _normalizeClass(["selectSupplierSB", { isLinkMode: _ctx.supplyInfo.isLinkMode }])
      }, [
        _createVNode(_component_vSelect, {
          style: {"height":"25px"},
          options: _ctx.opSuppliers,
          modelValue: _ctx.item.c_supplier_id,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.item.c_supplier_id) = $event)),
          label: "c_supplier_name",
          reduce: (label) => label.c_supplier_id,
          disabled: 
            //ロック機能による編集不可
            (_ctx.item.c_supply_flag_lock == 1 &&
              _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
            //リンクモード時は編集不可
            _ctx.supplyInfo.isLinkMode ||
            //支払確定済みによる編集不可
            (_ctx.item.c_supply_flag_paid == 1 &&
              _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
            //統合ロック
            _ctx.isHolisticlock()
          
        }, null, 8, ["options", "modelValue", "reduce", "disabled"])
      ], 2),
      (!_ctx.supplyInfo.isLinkMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("input", {
              type: "button",
              class: "btn-primary form-control form-control-sm",
              style: {"height":"25px","line-height":"13px"},
              disabled: 
            //ロック機能による編集不可
            (_ctx.item.c_supply_flag_lock == 1 &&
              _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
            //リンクモード時は編集不可
            _ctx.supplyInfo.isLinkMode ||
            //支払確定済みによる編集不可
            (_ctx.item.c_supply_flag_paid == 1 &&
              _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
            //統合ロック
            _ctx.isHolisticlock()
          ,
              value: "検索",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.selectSupplier()))
            }, null, 8, _hoisted_24)
          ]))
        : _createCommentVNode("", true),
      _hoisted_25
    ]),
    _createElementVNode("td", _hoisted_26, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        maxlength: "10",
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.item.cnvPrice) = $event)),
        disabled: 
          //ロック機能による編集不可
          (_ctx.item.c_supply_flag_lock == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //リンクモード時は編集不可
          _ctx.supplyInfo.isLinkMode ||
          //支払確定済みによる編集不可
          (_ctx.item.c_supply_flag_paid == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //統合ロック
          _ctx.isHolisticlock()
        ,
        onFocus: _cache[17] || (_cache[17] = ($event: any) => (_ctx.kanmaDel($event))),
        onBlur: _cache[18] || (_cache[18] = ($event: any) => (_ctx.kanmaIns($event)))
      }, null, 40, _hoisted_27), [
        [_vModelText, _ctx.item.cnvPrice]
      ])
    ]),
    _createElementVNode("td", _hoisted_28, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.item.c_supply_taxrate) = $event)),
        disabled: 
          //ロック機能による編集不可
          (_ctx.item.c_supply_flag_lock == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //リンクモード時は編集不可
          _ctx.supplyInfo.isLinkMode ||
          //支払確定済みによる編集不可
          (_ctx.item.c_supply_flag_paid == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //統合ロック
          _ctx.isHolisticlock()
        
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opTaxtate, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.code,
            key: option.code
          }, _toDisplayString(option.label), 9, _hoisted_30))
        }), 128))
      ], 8, _hoisted_29), [
        [_vModelSelect, _ctx.item.c_supply_taxrate]
      ])
    ]),
    _createElementVNode("td", _hoisted_31, [
      _createElementVNode("input", {
        type: "checkbox",
        style: {"height":"auto","width":"auto"},
        checked: (_ctx.item.c_supply_flag_chkclaim as any),
        disabled: 
          //ロック機能による編集不可
          (_ctx.item.c_supply_flag_lock == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //リンクモード時は編集不可
          _ctx.supplyInfo.isLinkMode ||
          //支払確定済みによる編集不可
          (_ctx.item.c_supply_flag_paid == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //統合ロック
          _ctx.isHolisticlock()
        ,
        onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.item.c_supply_flag_chkclaim = _ctx.cnvCb($event)))
      }, null, 40, _hoisted_32)
    ]),
    _createElementVNode("td", _hoisted_33, [
      _createVNode(_component_Mt_dtp, {
        contdate: _ctx.item.cnvDateExpPayment,
        "onUpdate:contdate": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.item.cnvDateExpPayment) = $event)),
        holidays: _ctx.mastersData,
        "onUpdate:holidays": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.mastersData) = $event)),
        class: "dtpJyutyuBulk jyutyuTable",
        disabled: 
          //ロック機能による編集不可
          (_ctx.item.c_supply_flag_lock == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //リンクモード時は編集不可
          _ctx.supplyInfo.isLinkMode ||
          //支払確定済みによる編集不可
          (_ctx.item.c_supply_flag_paid == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //統合ロック
          _ctx.isHolisticlock()
        
      }, null, 8, ["contdate", "holidays", "disabled"])
    ]),
    _createElementVNode("td", {
      style: {"text-align":"center","position":"relative"},
      class: _normalizeClass(["PAYMENT_FLG cwS_11 tdDisables", {
        isNoneLink: _ctx.item.c_supply_flag_paid == 1 && _ctx.item.c_pro2doc_id == null,
      }])
    }, [
      (_ctx.item.c_supply_flag_paid == 1 && _ctx.item.c_pro2doc_id == null)
        ? (_openBlock(), _createBlock(_component_VTooltip, {
            key: 0,
            class: "isNoneLinkIcon"
          }, {
            popper: _withCtx(() => [
              _createTextVNode(" 支払確定していますが、支払請求書と紐付いていません ")
            ]),
            default: _withCtx(() => [
              _hoisted_34
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.item.c_doc_id != null)
        ? (_openBlock(), _createElementBlock("i", {
            key: 1,
            class: "fal fa-external-link docLink",
            onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.linkDoc($event)), ["stop"]))
          }))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        type: "checkbox",
        style: {"height":"auto","width":"auto"},
        checked: (_ctx.item.c_supply_flag_paid as any),
        disabled: 
          !_ctx.authPayCheck.includes(_ctx.$store.state.id) ||
          //ロック機能による編集不可
          (_ctx.item.c_supply_flag_lock == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //リンクモード時は編集不可
          _ctx.supplyInfo.isLinkMode ||
          //支払確定済みによる編集不可
          (_ctx.item.c_supply_flag_paid == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //統合ロック
          _ctx.isHolisticlock()
        ,
        onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.item.c_supply_flag_paid = _ctx.cnvCb($event)))
      }, null, 40, _hoisted_35)
    ], 2),
    _createElementVNode("td", _hoisted_36, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.item.c_supply_remarks) = $event)),
        disabled: 
          //ロック機能による編集不可
          (_ctx.item.c_supply_flag_lock == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //リンクモード時は編集不可
          _ctx.supplyInfo.isLinkMode ||
          //支払確定済みによる編集不可
          (_ctx.item.c_supply_flag_paid == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          //統合ロック
          _ctx.isHolisticlock()
        
      }, null, 8, _hoisted_37), [
        [_vModelText, _ctx.item.c_supply_remarks]
      ])
    ])
  ], 34))
}